import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./saturday.css";
import { useNavigate } from "react-router-dom";
import apiServiceHandler from "../../service/apiService";
import { Share2 } from "lucide-react";
import "toastr/build/toastr.min.css";
import toastr from "toastr";

const SaturdayComp = ({weeklyScore}) => {

  const [showModal, setShowModal] = useState(false);
  const [score, setScore] = useState(0)

  const handleClose = () => setShowModal(false);

  const fetchData = async () => {
    try {
      const response = await apiServiceHandler("POST", "api/weekTask/saturday", { "date": new Date() });
      const apiResponse = response.data;
      if(Object.keys(apiResponse).length) {
      setScore(apiResponse[Object.keys(apiResponse)])
      }

    }
    catch(error) {
      throw new Error(error, 'error message')
    }
  }
  const navigate = useNavigate()

  const setModal = async () => {
    // setShowModal(true)
    const data = new FormData();
    const content = 
    `✅ My STG90 Journal Score for this week is ${score} / 44

    Join me in celebrating this win. 🙌
    
    I'm proud of my accomplishments and fired up to go after it again next week!`

    data.append("file", null);
    data.append("content", content);
    data.append("groupId", "6734e407890f24467cd112a0");
    data.append("mediaType","text");
    data.append("status", 1);

    await apiServiceHandler("POST", "api/post", data);
    toastr.success("Weekly points progress shared successfully in the community!")

    const timer = setTimeout(() => {
      navigate("/groups/group/6734e407890f24467cd112a0")
    }, 2000); // 3000ms = 3 seconds

    return () => clearTimeout(timer); // Cleanup timer on unmount

  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div className="container">
      <div className="saturday-container">
        <h2>Great Work!!</h2>
        <p className="saturday-desc">
          You earned <span className="earn-points">{weeklyScore}</span> out of{" "}
          <span className="total-points">44</span> points this week
        </p>
      </div>
      <button
        type="button"
        className="share-btn"
        // onClick={handleAddTextarea}
      >
        <span className="share-button__label" onClick={() => setModal()}>SHARE WITH THE COMMUNITY</span>
        <Share2 style={{ marginRight: "1rem" }} />
      </button>
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Work in Progress</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          This feature is still a work in progress. Please stay tuned for
          updates!
        </Modal.Body>
        <Modal.Footer>
          <Button style={{background: '#d1b794', border: 'none'}} onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SaturdayComp;
